import src from "IMAGE";
export default { src, width: 10, height: 10, blurWidth: 8, blurHeight: 8, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAANUlEQVR42r2LoQ0AIBADPySoVyhULat1m67ZNch7cISzdxfxFJIjM9tV2l6S5jGosySAHn/Zgj8JjKhK+0sAAAAASUVORK5CYII="};
